/**
 * Frontend Browser Detection Scripts.
 *
 * @package WMpremiere
 * @since 0.1.1
 */

(function( $ ){

	wmPremier.BDContainsString = function( haystack, needle ) {
		if ( ! Array.isArray( needle ) ) {
			needle = [ needle ];
		}

		var result = false;

		needle.forEach(
			function( e ) {
				if ( 0 <= haystack.indexOf( e ) ) {
					result = true;
				}
			}
		);

		return result;
	}

	wmPremier.frontBrowserDetect = function() {
		var browserWarnings  = $( '.wmp-browser-warning' );
		var browser          = browserDetect();
		var browserUserAgent = window.navigator.userAgent.toLowerCase();
		var browserPlatform  = browser && browser.os ? browser.os.toLowerCase() : '';
		var browserName      = browser && browser.name ? browser.name.toLowerCase() : '';
		var browserIsMobile  = browser && browser.mobile ? browser.mobile : '';
		browserWarnings.each(
			function() {
				var thisWarning         = $( this );
				var extraWarnings       = thisWarning.attr( 'data-wmp-warnings-extra' );
				var matchesExtraWarning = false;
				if ( undefined !== extraWarnings && extraWarnings.length ) {
					extraWarnings = extraWarnings.split( ',' );
					if ( extraWarnings.length ) {
						var extraWarning;
						extraWarnings.some(
							function( elem, index ) {
								extraWarning = extraWarnings[index].toLowerCase();
								if (
									( 'firefox' === extraWarning && 'firefox' === browserName )
									|| ( 'firefox' === extraWarning && wmPremier.BDContainsString( browserUserAgent, [ 'firefox' ] ) )
									|| ( 'iOS' === extraWarning && 'iOS' === browserPlatform )
									|| ( extraWarning === browserName
										&& wmPremier.BDContainsString( browserUserAgent, [ extraWarning ] )
									)
									|| (
										wmPremier.BDContainsString( extraWarning, [ 'edge' ] )
										&& wmPremier.BDContainsString( browserUserAgent, [ 'edg/', 'edge/' ] )
									)
									|| ( 'opera' === extraWarning && extraWarning === browserName )
								) {
									matchesExtraWarning = true;
									return true;
								}
							}
						);
					}
				}

				if (
					(
						( 'iOS' === browserPlatform || browserIsMobile )
						&& wmPremier.BDContainsString( browserUserAgent, [ 'cpu iphone os', 'iphone' ] )
					)
					|| (
						wmPremier.BDContainsString( browserPlatform, [ 'windows' ] )
						&& (
							wmPremier.BDContainsString( browserName, [ 'internet explorer', 'ie' ] )
							|| wmPremier.BDContainsString( browserName, [ 'edge' ] )
							|| wmPremier.BDContainsString( browserUserAgent, [ 'edg/', 'edge/' ] )
						)
					)
					|| matchesExtraWarning
				) {
					console.log( 'Showing browser/device warning.' );

					var thisTarget = $( '#' + thisWarning.attr( 'data-wmp-target' ) );

					if ( thisTarget.length ) {
						thisTarget.html( thisWarning.attr( 'data-wmp-error-msg' ) );
					}

					// Handle exceptional browser warning.
					if ( matchesExtraWarning ) {
						var copyClipMsg     = $( '.wmp-copy-clip-msg' );
						var copyLoginURLBtn = $( '.wmp-copy-clip-btn' );
						if ( copyLoginURLBtn.length ) {
							copyLoginURLBtn.each(
								function() {
									$( this ).on(
										'click',
										function(e) {
											e.preventDefault();
											thisElem = $( this );
											Clipboard.copy( thisElem.attr( 'data-wmp-copy-clip' ) );
											copyClipMsg.hide();
											thisElem.next( '.wmp-copy-clip-msg' ).show();
										}
									);
								}
							);
						}
					}
				}
			}
		);

		// Populate Formidable forms browser and platform hidden fields.
		var populateFrmBrowserHiddenFields = function() {
			var contactForms = $( '.frm_forms form' );
			contactForms.each(
				function() {
					var thisForm         = $( this );
					var browserNameField = thisForm.find( 'input.field_wmp_browser_name' );
					if ( browserNameField.length ) {
						browserNameField.val( browser.name );
					}
					var userAgentField = thisForm.find( 'input.field_wmp_browser_user_agent' );
					if ( userAgentField.length ) {
						userAgentField.val( window.navigator.userAgent );
					}
					var platformField = thisForm.find( 'input.field_wmp_browser_platform' );
					if ( platformField.length ) {
						platformField.val( browser.os );
					}
					var deviceField = thisForm.find( 'input.field_wmp_device_type' );
					if ( deviceField.length ) {
						deviceField.val( ( browserIsMobile ? 'Mobile.' : 'This is not a mobile device.' ) );
					}
				}
			);
		}
		populateFrmBrowserHiddenFields();

		// Make sure forms loaded via ajax get browser fields updated.
		var diviModules = $( '.et_pb_module' );
		diviModules.on(
			'wmp_session_qa_form_update',
			function () {
				populateFrmBrowserHiddenFields();
			}
		);

		// Populate Login forms browser and platform hidden fields.
		var browserDetectForms = $( '.browser-detect-form' );
		if ( browserDetectForms.length ) {
			var i = 1;
			browserDetectForms.each(
				function () {
					var thisForm = $( this );

					// Add Browser name hidden field to form.
					$( '<input type="hidden" value="' + browser.name + '" />' )
					.attr( "id", "wmp_browser_name_" + i )
					.attr( "name", "wmp_browser_name" )
					.appendTo( thisForm );
					// Add User agent hidden field to form.
					$( '<input type="hidden" value="' + window.navigator.userAgent + '" />' )
					.attr( "id", "wmp_browser_user_agent_" + i )
					.attr( "name", "wmp_browser_user_agent" )
					.appendTo( thisForm );
					// Add Browser platform hidden field to form.
					$( '<input type="hidden" value="' + browser.os + '" />' )
					.attr( "id", "wmp_browser_platform_" + i )
					.attr( "name", "wmp_browser_platform" )
					.appendTo( thisForm );
					// Add Device type hidden field to form.
					$( '<input type="hidden" value="' + ( browserIsMobile ? 'mobile' : 'not-mobile' ) + '" />' )
					.attr( "id", "wmp_device_type_" + i )
					.attr( "name", "wmp_device_type" )
					.appendTo( thisForm );
					i++;
				}
			);
		}
	};

	// Initialize on doc-ready.
	$( wmPremier.frontBrowserDetect );

})( jQuery );
